<template>

  <div>
    <div style="position: absolute; width: 100%; height: 100%; min-height: 50em; min-width: 50em" ref="map"></div>
     <section style="position: absolute; width: 100%; height: 100%; pointer-events: none;" class="section is-main-section">
      <div style="position: relative;" class="columns">
        <div style="pointer-events: all;" class="column is-one-third">
          <card-component title="Temperature" icon="thermometer">
            <plot style="height:15em;" v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" yLabel='Temperatur [°C]' :traces="[activeStationID+'/weather_tre200s0']" :traceNames="[activeStationName]"></plot>
          </card-component>
          <card-component title="Humidity" icon="water-percent">
            <plot style="height:15em;" v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" yLabel='Humidity [%]' :traces="[activeStationID+'/weather_ure200s0']" :traceNames="[activeStationName]"></plot>
          </card-component>
          <card-component title="Rain" icon="weather-pouring">
            <plot style="height:15em;" v-bind:timeCursor="timeCursor" v-on:update:timeCursor="updateCursor" v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" yLabel='Percipitation [mm/10min]' :traces="[activeStationID+'/weather_rre150z0']" :traceNames="[activeStationName]"></plot>
          </card-component>
        </div>
      </div>
     </section>
  </div>
</template>
<style>
canvas {
  outline: none;
}
</style>
<script>
import Plot from '@/components/TN-Plot'
import { Map } from 'maplibre-gl'
import CardComponent from '@/components/CardComponent'
import store from '@/store'
require('maplibre-gl/dist/maplibre-gl.css')

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

export default {
  name: 'weather',
  components: {
    Plot,
    CardComponent
  },
  mounted: function () {
    this.map = new Map({
      container: this.$refs['map'],
      style: 'https://static.tcnd.app/map/style_rail.json',
      hash: true,
      transformRequest: (url, resourceType) => {
        if (url.match(window.location.origin)) {
          return {
            url: url,
            headers: {
              Authorization: 'Bearer ' + store.state.userToken
            }
          }
        }
      }
    })
    this.map.on('load', () => {
      this.map.addSource('weatherstations', {
        type: 'geojson',
        data: window.location.origin + '/api/geo/weather_stations'
      })
      this.map.addLayer({
        id: 'weatherstations',
        type: 'symbol',
        source: 'weatherstations',
        layout: {
          'icon-image': 'triangle-stroked-15',
          'icon-anchor': 'center',
          'text-field': '{id}',
          'text-font': ['Noto Sans Regular'],
          'text-offset': [1.5, 0]
        },
        paint: {
          'text-halo-color': 'rgb(255,239,221)',
          'text-halo-width': 3,
          'text-color': 'rgb(0,0,0)'
        }
      })
      let eClick = (e) => {
        this.activeStationID = e.features[0].properties.id
        this.activeStationName = e.features[0].properties.name
      }
      this.map.on('click', 'weatherstations', eClick)
    })
  },
  data () {
    return {
      id: null,
      timeRange: [yesterday(), new Date()],
      timeCursor: 0,
      activeStationID: 'VIS',
      activeStationName: 'Visp'
    }
  },
  methods: {
    updateRange: function (val) {
      // console.log('updated range from event', val)
      this.timeRange = val
    },
    updateCursor: function (val) {
      this.timeCursor = val
    }
  }
}

</script>
